<template>
  <div class="mainFlex" >

    <div class=" messageThread">
      <br>
      <br>
      <div class="list-group" v-for="item in currentHazard" :key="item.objectId">
        <div class="col-12">
          <div class="row">
            <div class="col-10">
              <h3 class="font-weight-bold">
                {{item.hazardType}}: #{{item.objectId}}
              </h3>

            </div>
            <a href="#" class="col-1" v-on:click="closeFlexContainer" v-b-tooltip.hover title="Close">
              <i class="fas fa-2x fa-times-circle"></i>
            </a>

          </div>
          <div class="list-group-item list-group-item-action">
            <div class="row">
              <div class="col-1">
                <i class="fa fa-user"></i>
              </div>
              <div class="col-10">
                <div class="d-flex w-100 justify-content-between">
                  <small>{{item.createdBy}}</small>
                  <small class="text-muted">{{getFormattedDate(item.date)}}</small>


                </div>
                <div class="d-flex w-100 justify-content-between">
                  <p class="mb-0 font-weight-bold">
                    {{item.requestDetails}}
                  </p>
                </div>
              </div>
            </div>
            <div v-if="item.fileId" class="row">
              <div class="col-1">

              </div>
              <div class="col-8">
                <i>
                  <small>
                    {{(item.fileName.length>=attachmentNameLengthLimit?item.fileName.split(",")[0].substring(0,attachmentNameLengthLimit)+'...'+item.fileName.split(".")[item.fileName.split(".").length-1]:item.fileName)}}
                  </small>
                </i>
              </div>
              <div class="col-2">
                <button type="button" v-on:click="downloadFile(item.fileId, 'hazardFile')" class="btn btn-light btn-sm mb-xl-2"><i class="fas fa-download"></i></button>
              </div>
            </div>
          </div>
        </div>
        <br>
      </div>
      <div class="list-group" v-for="item in currentComments" :key="item.objectId">
        <div class="row">
          <div class="col-1"></div>
          <div class="col-10">
            <div class="list-group-item list-group-item-action">
              <div class="row">
                <div class="col-1">
                  <i class="fa fa-user"></i>
                </div>
                <div class="col-11">
                  <div class="d-flex w-100 justify-content-between">
                    <small>{{item.author_name}}</small>
                    <!-- <small class="text-muted">{{new Date(item.created_at).toISOString().split('T')[0]}}</small> -->
                    <small class="text-muted pl-1">{{item.dateCreated}}</small>


                  </div>
                  <div class="d-flex w-100 justify-content-between">
                    <p class="mb-0 font-weight-normal">
                      <small>{{item.comment_details}}</small>
                    </p>
                  </div>
                  <div class="row" v-for="(attachment, attIndex) in item.commentAttachments" :key="attIndex">
                    <div class="col-8">
                      <small>{{(attachment.fileName.length>=attachmentNameLengthLimit?attachment.fileName.split(",")[0].substring(0,attachmentNameLengthLimit)+'...'+attachment.fileName.split(".")[attachment.fileName.split(".").length-1]:attachment.fileName)}}</small>
                    </div>
                    <div class="col-2">
                      <button type="button" v-on:click="downloadFile(attachment.fileId, 'commentFile')" class="btn btn-light btn-sm mb-xl-2"><i class="fas fa-download"></i></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br>
      </div>
    </div>
    <div class="messageBox bg-transparent border-top">
      <div class="row container mt-xl-3 mt-lg-2" v-if="!isCurrentHazardApproved">
        <div class="col-xl-1 col-lg-12">
          <button type="button" v-on:click="toggleFileModal" class="btn btn-light btn-sm mb-xl-2"><i class="fas fa-paperclip"></i></button>
        </div>
        <div class="col-xl-8 col-lg-12">
          <textarea class="form-control" rows="3" v-model="newComment" id="newCommentTextArea"></textarea>
        </div>
        <div class="col-xl-3 col-lg-12">
          <button type="button" :disabled="newComment==''" class="col-xl-12 col-lg-6 btn btn-outline-primary mb-xl-2" v-on:click="addComment">
            <!-- <img class="img-fluid fas fa-comment"> -->
            Submit
          </button>
          <template v-if="userName==currentUserName">
            <button type="button" :disabled="newComment==''" class="col-xl-12 col-lg-6 btn btn-outline-success align-bottom" v-on:click="approveComment">
              <!-- <img class="img-fluid fas fa-check"> -->
              Approve
            </button>
          </template>
        </div>
      </div>
    </div>
    <modal :show.sync="openFileModalFlag">
      <template slot="header">
        <h5 class="modal-title">Upload Files</h5>
      </template>
      <template v-if="displayFilesFlag">
        <div class="row col-12" v-for="(item,index) in commentAttachments" :key="index">
          <div class="col-1">
            <button type="button" v-on:click="removeFileFromList(index)" class="btn btn-light btn-sm mb-xl-2"><i class="fas fa-times"></i></button>
          </div>
          <div class="col-8" style="overflow:hidden">
            {{(item.name.length>=attachmentNameLengthLimit?item.name.split(",")[0].substring(0,attachmentNameLengthLimit)+'...'+item.name.split(".")[item.name.split(".").length-1]:item.name)}}
          </div>
          <br>
          <br>
        </div>
      </template>
      <div class="row col-12">
        <div class="col-12">
          <b-form-file
            id="commentAttachmentContainer"
            v-model="file"
            ref="fileToUpload"
            :state="null"
            placeholder="Choose a file..."
            @change="attachFile"
            :file-name-formatter="function(){return 'Choose a file...'}"
            multiple
          ></b-form-file>
        </div>
      </div>
      <template slot="footer">
        <b-button type="secondary" @click="toggleFileModal">Close</b-button>
      </template>
    </modal>
  </div>
</template>

<script>
/*eslint-disable*/
import Vue from 'vue';
import modal from "@/components/Modal";
// import SuiVue from 'semantic-ui-vue';
// import 'semantic-ui-css/semantic.min.css';
// Vue.use(SuiVue)
import axios from "axios"
import {baseApiUrl, appBaseUrl} from "../../config.js";
export default {
  name: 'FlexContainer',
  components: {
    modal
  },
  data() {
    return {
      newComment:"",
      hazardSceneLayer: null,
      openFileModalFlag: false,
      file: null,
      displayFilesFlag: false,
      attachmentNameLengthLimit: 25
    }
  },
  computed: {
    webscene: {
      get() {
        return this.$store.state.mapModule.mapWebScene
      }
    },
    currentComments: {
      get() {
        return this.$store.state.mapModule.currentComments
      }
    },
    currentHazard: {
      get() {
        return this.$store.state.mapModule.currentHazard
      }
    },
    currentHazardId: {
      get() {
        return this.$store.state.mapModule.currentHazardId
      }
    },
    currentUserName: {
      get() {
        if (this.$store.state.mapModule.currentHazard) {
          return this.$store.state.mapModule.currentHazard[0].userName
        }
        else {
          return null
        }
      }
    },
    isCurrentHazardApproved: {
      get() {
        if (this.$store.state.mapModule.currentHazard) {
          return this.$store.state.mapModule.currentHazard[0].approvalStatus=="Approved"?true:false
        }
        else {
          return null
        }
      }
    },
    currentHazardApprovalState: {
      get() {
        if (this.$store.state.mapModule.currentHazard) {
          return this.$store.state.mapModule.currentHazard[0].approvalStatus.toLowerCase()
        }
        else {
          return null
        }
      }
    },
    userName: {
      get() {
        return this.$store.state.mapModule.userName
      }
    },
    user: {
      get() {
        return this.$store.state.mapModule.user
      }
    },
    discipline: {
      get() {
        if (this.$store.state.mapModule.currentHazard) {
          return this.$store.state.mapModule.currentHazard[0].discipline
        }
        else {
          return null
        }
      }
    },
    hazardType: {
      get() {
        if (this.$store.state.mapModule.currentHazard) {
          return this.$store.state.mapModule.currentHazard[0].hazardType
        }
        else {
          return null
        }
      }
    },
    severity: {
      get() {
        if (this.$store.state.mapModule.currentHazard) {
          return this.$store.state.mapModule.currentHazard[0].severity
        }
        else {
          return null
        }
      }
    },
    commentAttachments: {
      get() {
        return this.$store.state.mapModule.commentAttachments
      }
    }
  },
  watch: {
    currentComments: function() {
      const current = this
      if (current.currentComments) {
        console.log(current.currentComments)
      }
    },
    currentHazard: function() {
      const current = this
      if (current.currentHazard) {
        console.log(current.currentHazard)
      }
    }
  },
  methods: {
    approveComment: function() {
      // call addComment
      const current = this
      current.saveComment(true).then(data=>{
        current.newComment = ""
        var payload = {
          objectId: current.currentHazardId,
          comment: data.result,
          decision: true,
          approvalStateCode: "approved"
        }
        current.$store.commit("mapModule/addNewComment", payload)
        current.$store.dispatch("mapModule/setCurrentHazardDetails", current.currentHazardId)
        var updatePayload = {
          objectId: current.currentHazardId,
          decision: true,
          approvalStateCode: "approved"
        }
        current.$store.commit("mapModule/finalizeHazard", updatePayload)
        // current.sendHazardCommentEmail(data.result, true)
        // change value of decision in item in hazardList from state
      })
    },
    addComment: function() {
      const current = this
      current.saveComment().then(data=>{
        console.log(data);
        current.$store.commit("mapModule/clearAttachments")
        current.newComment = ""
        var payload = {
          objectId: current.currentHazardId,
          comment: data.result,
          decision: current.isCurrentHazardApproved,
          approvalStateCode: current.currentHazardApprovalState
        }
        current.$store.commit("mapModule/addNewComment", payload)
        current.$store.dispatch("mapModule/setCurrentHazardDetails", current.currentHazardId)
        current.sendHazardCommentEmail(data.result, current.isCurrentHazardApproved)
      })
    },
    saveComment: function(approveFlag) {
      const current = this
      var isApproved = approveFlag?approveFlag:current.isCurrentHazardApproved
      var approvalStateCode = approveFlag?'approved':current.currentHazardApprovalState
      var attachmentsSuccessfulCount = 0
      return new Promise(function(resolve, reject) {
        var data = {
          hazardId:    current.currentHazardId,
          discipline:   current.discipline,
          decision:     isApproved,
          authorName:   current.user.email,
          commentDetails: current.newComment,
          approvalStateCode: approvalStateCode
        }
        var url = baseApiUrl + "newComment"
        var config  = {
          responseType: 'json'
        }
        axios.post(url, data, config).then((result)=>{
          if(result.data.status == "success"){
            if (current.commentAttachments.length > 0) {
              // result.data.commentAttachments = []
              var fileURL = baseApiUrl + "addAttachment"
              current.commentAttachments.forEach(item=>{
                var fileData = new FormData();
                fileData.append("fileinput"       , item);
                fileData.append("commentId"         , result.data.result.id);
                fileData.append("filename"        , item.name);
                fileData.append("filetype"        , item.type);
                var fileConfig = {
                  headers: {
                    'content-type': 'application/octet-stream'
                  },
                  responseType: 'json'
                }
                axios.post(fileURL, fileData,   fileConfig).then(fileResult=>{
                  result.data.result.commentAttachments.push(fileResult.data)
                  attachmentsSuccessfulCount+=1
                  if (attachmentsSuccessfulCount==current.commentAttachments.length) {
                    resolve(result.data)
                  }
                })
                .catch(error=>{
                  console.log(error);
                })
              })
            }
            else {
              resolve(result.data)
            }
          }
          else if(result.data.status == "failed"){
            current.$notify({
              group: 'errors',
              title: "Failed to create hazard",
              type: 'error',
              text: result.data.message,
              width: 500,
              duration: -1
            })
          }

        })
        .catch(error=>{
          reject(error)
        })
      });
      // add hazard to database,
      // refresh hazard list from database dataset
    },
    closeFlexContainer: function() {
      var flexContainer = document.getElementById("flexContainer")
      var map = document.getElementById("mapContainer")
      flexContainer.classList.add("displayNone")
      map.classList.remove("col-6")
      map.classList.add("col-9")
      // data clean
      this.newComment = ""
      this.$store.commit("mapModule/clearAttachments")
    },
    sendHazardCommentEmail: function(data, decision) {
      const current = this
      var url = baseApiUrl + "sendHazardCommentEmail"
      var data    = {
        hazardId: current.currentHazardId,
        name: data.author_name,
        comment: data.comment_details,
        discipline: current.discipline,
        hazardType: current.hazardType,
        severity: current.severity,
        date: data.created_at,
        approvalstatus: decision,
        appBaseUrl: appBaseUrl
      }
      var config  = {
        responseType: 'json'
      }
      axios.post(url, data, config).then((result)=>{
        console.log(result.data);
      }).catch((error)=> {
        console.log(error);
      })
    },
    getFormattedDate: function(dateItem) {
      let date = new Date(dateItem)
      let year = date.getFullYear().toString();
      let month = date.getMonth() + 1;
      month = month.toString().padStart(2, '0');
      let day = date.getDate().toString().padStart(2, '0');
      let hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
      let am_pm = date.getHours() >= 12 ? "pm" : "am";
      hours = hours < 10 ? "0" + hours : hours;
      let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let time = hours + ":" + minutes + " " + am_pm;
      return year + '-' + month + '-' + day + " " + time;
    },
    toggleFileModal: function() {
      const current = this
      console.log(current.openFileModalFlag);
      current.openFileModalFlag = !current.openFileModalFlag
      console.log(current.openFileModalFlag);
    },
    attachFile: function(event) {
      const current = this
      current.displayFilesFlag = false
      var files = event.target.files
      files.forEach(item=>{
        current.$store.commit("mapModule/addAttachment", item)
      })
      current.displayFilesFlag = true
      current.file = null
    },
    removeFileFromList: function(index) {
      this.$store.commit("mapModule/removeAttachment", index)
    },
    downloadFile: function(fileId, type) {
      let formData = new FormData();
      let url = baseApiUrl + "downloadAttachment";
      let config = {
        headers: {
          'content-type': 'application/octet-stream'
        },
        responseType: 'blob'
      }
      formData.append("fileId", fileId);
      formData.append("type", type);
      axios.post(url, formData, config).then((result) => {
        var disposition = result.headers['content-disposition'];
        // fix this matches
        var matches = /=(.*)/.exec(disposition);
        var filename = (matches != null && matches[1] ? matches[1] : '').replace(/"*/g,"");
        // filename = filename.replace(/"*/g,"");
        var type = result.headers['content-type'];
        var link = document.createElement('a');

        document.body.appendChild(link)
        link.style = "display: none"
        var blob = new Blob(
          [result.data],
          {type: result.headers['content-type']}
        );
        var url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(url);
        // link.remove();
      });
    },
  }

}
</script>

<style lang="css" scoped>
  .mainFlex {
    height: 93vh;
    max-height: 93vh;
    display:block;
  }
  .messageThread {
    height: 85%!important;
    max-height: 85%!important;
    overflow: hidden;
    overflow-y: scroll;
  }
  .messageBox {
    height: 14.6%!important;
    /* border-top: ridge; */
    border-top-color: lightgray;
  }
  textarea {
    resize: none;
  }
  a {
    color: gray;
  }
  a:hover {
    color: gray;
  }
</style>
